import { InjectionToken, Injectable, Inject, Component, Input, Output, Renderer2, ElementRef, EventEmitter, ChangeDetectionStrategy, NgModule, defineInjectable, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const DISQUS_SHORTNAME = new InjectionToken('DISQUS_SHORTNAME');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DisqusService {
    /**
     * @param {?} shortname
     * @param {?} _document
     */
    constructor(shortname, _document) {
        this.shortname = shortname;
        this._document = _document;
    }
    /**
     * @return {?}
     */
    get DISQUS() {
        return this._document.defaultView.DISQUS;
    }
    /**
     * @return {?}
     */
    get disqus_config() {
        return this._document.defaultView.disqus_config;
    }
    /**
     * @param {?} config
     * @return {?}
     */
    set disqus_config(config) {
        this._document.defaultView.disqus_config = config;
    }
}
DisqusService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
DisqusService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [DISQUS_SHORTNAME,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
/** @nocollapse */ DisqusService.ngInjectableDef = defineInjectable({ factory: function DisqusService_Factory() { return new DisqusService(inject(DISQUS_SHORTNAME), inject(DOCUMENT)); }, token: DisqusService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DisqusComponent {
    /**
     * @param {?} renderer
     * @param {?} el
     * @param {?} dService
     */
    constructor(renderer, el, dService) {
        this.renderer = renderer;
        this.el = el;
        this.dService = dService;
        /**
         * DISQUS events
         */
        this.newComment = new EventEmitter(true);
        this.ready = new EventEmitter(true);
        this.paginate = new EventEmitter(true);
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        /** Reset Disqus if any input changed */
        if (!this.dService.DISQUS) {
            this.addDisqusScript();
        }
        else {
            this.reset();
        }
    }
    /**
     * Add DISQUS script
     * @return {?}
     */
    addDisqusScript() {
        /** Set DISQUS config */
        this.dService.disqus_config = this.getConfig();
        /** @type {?} */
        const disqusScript = this.renderer.createElement('script');
        disqusScript.src = `//${this.dService.shortname}.disqus.com/embed.js`;
        disqusScript.async = true;
        disqusScript.type = 'text/javascript';
        this.renderer.setAttribute(disqusScript, 'data-timestamp', new Date().getTime().toString());
        this.renderer.appendChild(this.el.nativeElement, disqusScript);
    }
    /**
     * Reset DISQUS with the new config
     * @return {?}
     */
    reset() {
        this.dService.DISQUS.reset({
            reload: true,
            config: this.getConfig()
        });
    }
    /**
     * Create DISQUS config from the inputs
     * @return {?}
     */
    getConfig() {
        /** @type {?} */
        const self = this;
        return function () {
            this.page.identifier = self.identifier;
            this.page.url = self.validateUrl(self.url);
            this.page.title = self.title;
            this.category_id = self.category;
            this.language = self.language;
            /* Available callbacks are afterRender, onInit, onNewComment, onPaginate, onReady, preData, preInit, preReset */
            this.callbacks.onNewComment = [(e) => {
                    self.newComment.emit(e);
                }];
            this.callbacks.onReady = [(e) => {
                    self.ready.emit(e);
                }];
            this.callbacks.onPaginate = [(e) => {
                    self.paginate.emit(e);
                }];
        };
    }
    /**
     * @param {?} url
     * @return {?}
     */
    validateUrl(url) {
        /** Validate URL input */
        if (url) {
            /** @type {?} */
            const r = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
            if (r.test(url)) {
                return url;
            }
            else {
                console.warn('[Disqus]: Invalid URL');
            }
        }
        /** DISQUS will fallback to "Window.location.href" when URL is undefined */
        return undefined;
    }
}
DisqusComponent.decorators = [
    { type: Component, args: [{
                selector: 'disqus',
                template: '<div id="disqus_thread"></div>',
                changeDetection: ChangeDetectionStrategy.OnPush
            }] }
];
/** @nocollapse */
DisqusComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: DisqusService }
];
DisqusComponent.propDecorators = {
    url: [{ type: Input }],
    identifier: [{ type: Input }],
    title: [{ type: Input }],
    category: [{ type: Input }],
    language: [{ type: Input }],
    newComment: [{ type: Output }],
    ready: [{ type: Output }],
    paginate: [{ type: Output }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class DisqusModule {
    /**
     * @param {?} shortname
     * @return {?}
     */
    static forRoot(shortname) {
        return {
            ngModule: DisqusModule,
            providers: [
                { provide: DISQUS_SHORTNAME, useValue: shortname }
            ]
        };
    }
}
DisqusModule.decorators = [
    { type: NgModule, args: [{
                declarations: [DisqusComponent],
                exports: [DisqusComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { DisqusModule, DISQUS_SHORTNAME, DisqusService, DisqusComponent as ɵa };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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